var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('OzBaseDialog',{attrs:{"dir":_vm.dir,"buttons":[
    {
      text: _vm.__('See detailed instructions.'),
      emit: 'proceed',
      colorScheme: 'primary',
    },
    {
      text: _vm.__('Cancel'),
      emit: 'cancel',
      colorScheme: 'secondary',
    } ]},on:{"cancel":_vm.cancel,"proceed":_vm.proceed},scopedSlots:_vm._u([{key:"baseDialogHeader",fn:function(){return [_c('div',{staticClass:"break-normal text-center font-sans font-semibold text-heading-3 text-dark-text-100 dark:text-light-text-100"},[_c('img',{staticClass:"select-none",attrs:{"src":_vm.iconUrl,"width":"64","height":"64","alt":_vm._f("__")('Location services')}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.title))])])]},proxy:true},{key:"baseDialogBody",fn:function(){return [_c('div',{staticClass:"mx-4 mb-4 text-left"},_vm._l((_vm.body),function(content,index){return _c('p',{key:index},[_vm._v(_vm._s(content))])}),0)]},proxy:true}],null,false,4001726726)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }